import request from '@/plugin/axios'
export function getOneclassPagedList (query) {
  return request({
    url: '/moblieapp/oneclassPagedlist',
    method: 'post',
    params: query
  })
}

export function getComplaintPagedList (query) {
  return request({
    url: '/moblieapp/ComplaintPagedlist',
    method: 'post',
    params: query
  })
}

export function getTwoclassPagedList (query) {
  return request({
    url: '/moblieapp/twoclassPagedlist',
    method: 'post',
    params: query
  })
}

export function editRoleUser (data) {
  return request({
    url: '/moblieapp/editroleuser',
    method: 'post',
    data: data
  })
}
export function saveOneclass (data) {
  return request({
    url: '/moblieapp/OneclassrSave',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveComplaint (data) {
  return request({
    url: '/moblieapp/ComplaintSave',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}

export function saveTwoclass (data) {
  return request({
    url: '/moblieapp/TwoclassrSave',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    success: {
      type: 'message',
      options: {
        message: '保存成功',
        type: 'success'
      }
    }
  })
}
export function updateOneclass (data) {
  return request({
    url: '/moblieapp/updateOneclass',
    method: 'post',
    data: data
  })
}

export function updateTwoclass (data) {
  return request({
    url: '/moblieapp/updateTwoclass',
    method: 'post',
    data: data
  })
}

export function delOneclass (data) {
  return request({
    url: '/moblieapp/oneclassDel',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}

export function delTwoclass (data) {
  return request({
    url: '/moblieapp/twoclassDel',
    method: 'post',
    data: data,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
export function delOneclasss (ids) {
  return request({
    url: '/user/batchdeloneclass',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
export function getOneclass (data) {
  return request({
    url: '/moblieapp/getOneclass',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}

export function getTwoclass (data) {
  return request({
    url: '/moblieapp/getTwoclass',
    method: 'post',
    data: data,
    loading: {
      type: 'nprogress',
      interval: 500
    }
  })
}
export function delTwoclasss (ids) {
  return request({
    url: '/user/batchdeltwoclass',
    method: 'delete',
    params: ids,
    success: {
      type: 'message',
      options: {
        message: '删除成功',
        type: 'success'
      }
    }
  })
}
